<!--
 * @Author: wangjiaxiang
 * @Date: 2022-04-06 10:38:22
 * @LastEditTime: 2022-11-02 16:46:27
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /xingmahui_front/src/views/contents/expertsView/list.vue
 *
-->
<template>
  <div>
    <div class="head-bg">
      <!-- 搜索组件 -->
      <van-sticky :z-index="10">
        <search
          ref="search"
          :select="select"
          @backHander="backHander"
          @changeParentData="getDataByTag"
          @endMonthsAge="endMonthsAge"
          @inputFocusHander="inputFocusHander"
        />
      </van-sticky>
      <!-- 栏目 -->
      <editRecommend
        :editRecommendList="ExpertsColumnList"
        :isExpertsView="true"
        @toDetails="toDetails"
      />
    </div>
    <!-- 瀑布流 -->
    <div class="content-list">
      <!-- 滚动分类 -->
      <classification
        ref="tabClassification"
        :isDisabled="isDisabled"
        :isExpertsView="1"
        :navHeight="0"
        :searchHeight="searchHeight"
        :tagList="tagList"
        :tagListTitle="tagListTitle"
        @changeTab="checkClassification"
        @classificationSuck="classificationSuck"
      />
      <div class="content">
        <van-list
          v-if="tagList.length > 1"
          v-model="pageWikipediaParams.loading"
          :error.sync="pageWikipediaParams.error"
          :finished="pageWikipediaParams.finished"
          :finished-text="pageWikipediaParams.bottomText"
          :immediate-check="false"
          error-text="请求失败，点击重新加载"
          @load="getArticleList(loadParameter)"
        >
          <waterfallComponents
            ref="waterfall"
            :itemKey="loadParameter.moduleType == 0 ? 'moduleId' : 'id'"
            class="water-fall"
            @clickHander="clickHander"
            @styleEnd="styleEnd"
          >
            <template slot-scope="props">
              <div
                :class="props.data.jumpType ? 'water-burial-point' : ''"
                :databanner="
                  JSON.stringify({
                    ...resourceNiche(props.data),
                    xmh5_ziyuanwei_position: props.index + 1,
                  })
                "
              >
                <div :class="'info'" :data="JSON.stringify(props.data)">
                  <div
                    v-lazy:background-image="
                      props.data.imgUrl || props.data.coverUrl
                    "
                    :style="
                      props.data.moduleType == 2
                        ? 'height:90px;'
                        : props.data.moduleType == 5
                        ? 'height:231px;'
                        : props.data.moduleType == 6
                        ? 'height:94px;'
                        : props.data.moduleType == 7
                        ? 'height:95px;'
                        : 'height:167px;'
                    "
                    :class="[
                      'info-img',
                      props.data.jumpType ? 'info-img-badius jumpHeight' : '',
                    ]"
                  >
                    <p
                      v-if="
                        loadParameter.moduleType > 0 &&
                        loadParameter.moduleType == 5 &&
                        !props.data.contentUrl &&
                        props.data.endTime
                          ? true
                          : !props.data.contentUrl && props.data.moduleType == 5
                          ? true
                          : false
                      "
                      :style="
                        isTimeTrue(props.data.startTime, props.data.endTime, 1)
                          ? 'background:linear-gradient(270deg, #F0BA3B 0%, #FED479 100%);'
                          : ''
                      "
                    >
                      <img
                        v-if="
                          isTimeTrue(
                            props.data.startTime,
                            props.data.endTime,
                            1
                          )
                        "
                        class="icon"
                        src="@/assets/images/common/playing.gif"
                      />
                      {{
                        isTimeTrue(props.data.startTime, props.data.endTime, 2)
                      }}
                    </p>
                    <i
                      v-if="!props.data.contentUrl && !props.data.jumpType"
                      class="play-btn"
                      src="@/assets/images/icon/off.png"
                    ></i>
                    <img
                      v-if="
                        loadParameter.moduleType > 0
                          ? (loadParameter.moduleType == 5 ||
                              loadParameter.moduleType == 7) &&
                            !props.data.contentUrl
                          : loadParameter.moduleType == 0
                          ? (props.data.moduleType == 5 ||
                              props.data.moduleType == 7) &&
                            !props.data.contentUrl
                          : ''
                      "
                      alt=""
                      class="share"
                      src="@/assets/images/expertsView/share.png"
                      @click.stop="share(props.data)"
                    />
                  </div>
                  <template v-if="props.data.jumpType === 3">
                    <div class="information-wxtag">
                      <openWxTag
                        :id="'information' + props.data.id"
                        :path="props.data.jumpTargetUrl"
                        :appId="props.data.miniProgramTypeAppId"
                        btnStyle="width:100%;height:300px"
                      ></openWxTag>
                    </div>
                  </template>
                  <div
                    class="bottom-content"
                    v-if="props.data.jumpType && props.data.resTitle"
                  >
                    <p class="item-title res_title">
                      {{ props.data.resTitle }}
                    </p>
                  </div>
                  <div class="bottom-content" v-if="!props.data.jumpType">
                    <p class="item-title">
                      {{ props.data.name }}
                    </p>
                    <div
                      v-if="!props.data.contentUrl"
                      class="item-tagAndPlaynum"
                    >
                      <span v-if="props.data.tagName" class="item-tag">{{
                        props.data.tagName
                      }}</span>
                      <p class="item-playnum">
                        <img
                          class="icon"
                          src="@/assets/images/expertsView/eyes2.png"
                        />
                        <span>{{
                          fomatterNum(
                            props.data.playNum || props.data.likeNum
                          ) || 0
                        }}</span>
                      </p>
                    </div>
                    <div
                      v-if="
                        loadParameter.moduleType > 0 &&
                        loadParameter.moduleType == 5 &&
                        !props.data.contentUrl &&
                        props.data.endTime &&
                        isTimeTrue(props.data.startTime, props.data.endTime, 3)
                          ? true
                          : !props.data.contentUrl &&
                            props.data.moduleType == 5 &&
                            isTimeTrue(
                              props.data.startTime,
                              props.data.endTime,
                              3
                            )
                          ? true
                          : false
                      "
                      class="reservation"
                      @click.stop="props.data.signId ? '' : signUp(props.data)"
                    >
                      <img
                        v-if="!props.data.signId"
                        alt=""
                        src="@/assets/images/expertsView/alarm.png"
                      />
                      <span>{{ props.data.signId ? "预约成功" : "预约" }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </waterfallComponents>
          <template #finished>
            <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
            我们会加油更新的 么么哒~
            <img
              class="icon"
              src="@/assets/images/expertsView/pentagram.png"
              style="width: 9px"
            />
          </template>
        </van-list>
      </div>
    </div>
    <!-- 星妈课堂海报 -->
    <div class="canvasposter" @touchmove.prevent @mousewheel.prevent>
      <div class="share_box">
        <img
          :src="src"
          alt=""
          class="share-image"
          @touchend="posterSaveEnd($event)"
          @touchstart="posterSaveStart($event)"
        />
        <mom-canvasPoster
          :painting="momPainting"
          class="poster"
          @close="close"
          @fail="fail"
          @success="success"
        >
        </mom-canvasPoster>
      </div>
    </div>
    <!-- 预约成功弹窗 -->
    <singUpTips :isShow.sync="isShow" :startTime="startTime" />
    <!-- 视频组件 -->
    <viewVideo
      ref="childVideo"
      :showVedio="showVedio"
      :userInfo="userInfo"
      :videoDetail="dataInfo"
      :videoId="dataInfo.id"
      :isCommonPopup="isCommonPopup"
      isHfindex="true"
      @hideVedio="hidevedioEvent"
      @isUserLogin="userLogin"
      @playerBuriedpoint="playerBuriedpoint"
      @switchoverVideoNext="switchoverVideoNext"
    />
    <!-- 登录注册弹窗 -->
    <!-- <login-tip
      :show="checkLogin"
      @confirmWay="confirmWay"
      @cancleWay="cancleWay"
    ></login-tip> -->
    <login-tip
      v-show="checkLogin"
      :bgStatus="2"
      @goLogin="confirmWay"
      @sendStatus="cancleWay"
    ></login-tip>
  </div>
</template>

<script>
//组件
import search from "@/components/contents/searchCommon/monthSearch.vue"; //搜索组件
import editRecommend from "../babyWikipedia/components/editRecommend.vue"; //编辑推荐
import classification from "../babyWikipedia/components/classification.vue"; // 滚动分类组件
import waterfallComponents from "@/components/contents/waterfallComponents.vue"; //瀑布流
import momCanvasPoster from "@/components/poster/canvas-poster.vue"; //星妈课堂海报
import singUpTips from "./components/signUpTips.vue"; //预约成功弹窗
import viewVideo from "./components/video.vue"; //视频组件
// import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件
import loginTip from "@/components/registerPop.vue"; //注册提示组件
import openWxTag from "@/components/common/openWeappTag/index.vue";
import * as until from "@/assets/js/common.js"; //公共方法
import { commonOperationEvent } from "@/utils/commonApiList";

// 方法
import {
  fomatterNum,
  getCookie,
  getmotherState,
  getUserInfo,
  globalGoLogin,
  isUserLogin,
  useModelTime,
  advertisJump,
  resourceNiche,
} from "@/assets/js/common.js";
import { drawPoster } from "@/components/poster/posterjs/painter.js"; //疫情星妈课堂海报
import { expertsView_content } from "@/assets/js/Exposure";
// api
import API from "@/utils/axiosApi/catipaldoctorApi"; //京城名医api
import API_ from "@/utils/axiosApi/foodApi.js";
import { xmhziyuanwei_data_expo } from "@assets/js/BuriedPointEvent"; // 营养厨房

const { interVal, clearTime } = useModelTime();
export default {
  name: "expertsViewList",
  data() {
    return {
      ExpertsColumnList: [], // 栏目列表
      tagListTitle: [],
      tagList: [], //tab选项卡 文章分类列表 所有二级标签
      isDisabled: false,
      searchHeight: 0, //搜索框高度
      positioning: 0, // 分类下拉定位的距离
      suckTheTop: false, // 是否吸顶
      dataList: [],
      pageWikipediaParams: {
        page: 1,
        size: 20,
        error: false,
        loading: false,
        bottomText: "",
        finished: false,
      }, // 分页配置参数
      periodid: 0, // 月龄id
      select: "全部", // 月龄name
      src: "", // 分享海报图片
      momPainting: {}, // 星妈课堂海报json数据
      bjdoctorPainting: {}, // 京城名医海报json数据
      articleId: 0,
      size: 0, //每次请求的数据里面会有推广活动 分页拿这个判断 不拿data数据长度做判断
      loadParameter: {
        moduleType: 0,
        id: 0,
      }, // list列表load数据
      userInfo: JSON.parse(localStorage.getItem("userInfo")), //用户数据
      startTime: "", //预约成功弹窗里的开始时间
      isShow: false, //预约弹窗是否显示
      showVedio: false, //视频组件是否显示
      dataInfo: {}, //视频信息
      checkLogin: false, //跳转登录弹框
      videoData: [], //当前页面所有视频数据
      // resourceList: [], //资源位数据
      playIndex: 0,
      isCommonPopup: false,
    };
  },

  components: {
    search,
    editRecommend,
    classification,
    waterfallComponents,
    momCanvasPoster,
    singUpTips,
    viewVideo,
    loginTip,
    openWxTag,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 解决在进入页面播放器存在问题
      vm.$nextTick(() => {
        if (!vm.$route.query.isFood && from.path !== "/replyComment") {
          vm.showVedio = false;
          vm.isCommonPopup = false;
        }
      });

      // 缓存页面
      vm.$store.commit("changeIncludes", [
        "home",
        "expertsViewIndex",
        "expertsViewList",
      ]);
    });
  },

  computed: {},

  created() {
    this.getRecommend();
  },

  mounted() {
    var shareDataParams = {
      shareLink: location.href.split("#")[0],
      shareDesc: "选新鲜的食材，做营养的料理，呵护宝宝一生健康。",
      shareTitle: "星妈营养厨房",
      imgUrl: "https://image-mom.feihe.com/wxshare/foodListShare.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
    sessionStorage.removeItem("isDoctorDetail"); //每次进入页面清除
    //初始化下拉分类
    this.$nextTick(() => {
      $(".tagAllList").delay(50).slideDown(300);
      $(".tagAllList").slideUp(300);
    });
    // 判断是否是分享进来的视频
    if (this.$route.query.hasOwnProperty("isFood")) {
      if (this.$route.query.isFood == 1) {
        this.getFoodDetail({ id: this.$route.query.videoId });
      } else {
        this.getDoctorDetail({ id: this.$route.query.videoId });
      }
    }
    if (
      this.isUserLogin() &&
      (this.$route.query.crmId || this.$route.query.sign)
    ) {
      // this.$router.push({
      //   path: "/phoneLogin?redirect=" + window.location.href,
      // });
      globalGoLogin();
    } else {
      this.addQrcodeNum(); //扫码增加分享量
    }

    var shareDataParams = {
      shareLink: location.origin + "/expertsView",
      shareDesc:
        "星妈会权威专家科普，哈佛专家、京城名医、营养名师，让你育儿不迷路~",
      shareTitle: "星专家",
      imgUrl: "https://image-mom.feihe.com/wxshare/zhuanjiashijiao.jpg", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },

  methods: {
    resourceNiche,
    interVal,
    clearTime,
    getmotherState,
    isUserLogin,
    fomatterNum,
    drawPoster,
    getCookie,
    getUserInfo,
    isTimeTrue(start, end, type) {
      if (start && end) {
        var start_time = new Date(
          new Date(Date.parse(start.replace(/-/g, "/")))
        ).getTime();
        var end_time = new Date(
          new Date(Date.parse(end.replace(/-/g, "/")))
        ).getTime();
        var current = new Date().getTime();
        switch (type) {
          case 1:
            return current > start_time && end_time > current;
          case 2:
            if (current > start_time && end_time > current) {
              return "直播中";
            } else if (current > end_time) {
              return "回放";
            } else {
              this.returnDate(start);
            }
          case 3:
            return current < start_time && current < end_time;
        }
      }
    },
    // 专题栏目接口
    getRecommend() {
      this.$http.get(
        "/breedWiki/recommend",
        { showLocation: 2 },
        (res) => {
          if (res.code == "200") {
            this.ExpertsColumnList = res.data;
            this.showListNav = true;
            this.$nextTick(() => {
              // 栏目没有数据直接吸顶效果
              if (this.ExpertsColumnList.length < 1) {
                this.classificationSuck(true);
              }
              this.searchHeight = $(".month_search").outerHeight(true);
              // 分类下拉点击页面定位的距离
              this.positioning =
                $(".content-list")[0].offsetTop - this.searchHeight + 1;
            });
          } else {
            this.$nextTick(() => {
              this.searchHeight = $(".month_search").outerHeight(true);
            });
          }
        },
        null,
        "lucky"
      );
    },
    // 专题栏目点击
    toDetails(item) {
      this.sensorsFn("推荐栏目", item.name);
      console.log(item, "推荐栏目");
      setTimeout(() => {
        location.href = item.contentUrl;
      });
    },
    // 月龄获取完毕
    endMonthsAge() {
      var babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      if (babyInfo) {
        let currentBaby = this.getCookie("babyNum");
        const currentBabyInfo = babyInfo.filter((item) => {
          return item.num == currentBaby;
        });
        // let babyIndex = babyInfo.findIndex((item, index) => {
        //   return item.num == currentBaby;
        // });
        // console.log("")
        this.periodid = currentBabyInfo[0] && currentBabyInfo[0].tag_id;
        // let babyIndex = babyInfo.findIndex((item, index) => {
        //   return item.num == currentBaby;
        // });
        // this.periodid = babyInfo[babyIndex !== -1 ? babyIndex : 0].tag_id;
        if (this.periodid == 1) {
          this.periodid = 2;
        } else if (this.periodid == 2) {
          this.periodid = 1;
        }
        this.select = this.$refs.search.optionList[this.periodid]?.name;
        this.periodid = this.$refs.search.optionList[this.periodid]?.id || "0";
      } else {
        this.periodid = "0";
        this.select = "全部";
      }
      this.getArticlClassify(); //获取列表分类
    },
    //获取分类标签
    getArticlClassify() {
      this.tagList = [];
      this.tagListTitle = [];
      this.$http.get(
        "/expertPerspective/type",
        {},
        (res) => {
          if (res.code === 200) {
            this.tagListTitle[0] = {};
            this.tagListTitle[0].tagList = [];
            for (let i = 0; i < Object.keys(res.data).length; i++) {
              this.tagList.push(...res.data[Object.keys(res.data)[i]]);
              // this.tagListTitle.push({
              //   // name: Object.keys(res.data)[i] == "class" ? "分类" : "标签",
              //   tagList: [...res.data[Object.keys(res.data)[i]]],
              // });
              for (
                let j = 0;
                j < res.data[Object.keys(res.data)[i]].length;
                j++
              ) {
                this.tagListTitle[0].tagList.push(
                  res.data[Object.keys(res.data)[i]][j]
                );
              }
            }

            this.tagList.unshift({ name: "最新推荐", id: 0, moduleType: 0 });
            this.getArticleList(this.tagList[0], 3333); //获取列表数据
            // this.getResourceData(); //获取资源位数据
          }
        },
        null,
        "lucky"
      );
    },
    // 切换分类点击
    checkClassification(item) {
      console.log(item);
      // 点击不同分类再请求
      // if (this.loadParameter.id != item.id) {
      this.sensorsFn("分类", "", item.name);
      this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
      this.pageWikipediaParams.page = 1;
      this.dataList = [];
      this.size = 0;
      this.videoData = [];
      this.pageWikipediaParams.loading = false;
      this.pageWikipediaParams.finished = false;
      this.loadParameter.moduleType = item.moduleType;
      this.loadParameter.id = item.id;
      this.getArticleList(item);
      this.$nextTick(() => {
        // 处于吸顶状态的时候点击分类切换固定状态
        if (this.suckTheTop) {
          $(window).scrollTop(this.positioning + 1);
        } else {
          $(".content").css("min-height", "100%");
        }

        // disabled状态清除禁用样式
        $(".isDisabled .van-tab").removeClass("van-tab--disabled");
      });
      // }
    },
    // 分类滚动吸顶触发
    classificationSuck(e) {
      if (e) {
        this.suckTheTop = true;
        $(".month_search").css({ backgroundColor: "#FFFFFF" });
      } else {
        this.suckTheTop = false;
        $(".month_search").css({ backgroundColor: "#ffb2de" });
      }
    },
    // 获取文章列表
    getArticleList(item) {
      // console.log(2222, this.resourceList);
      // console.log(item);
      // //
      // if (this.periodid != 0 && item.id == 0 && this.pageWikipediaParams.page === 1) {
      //   this.dataList = [...this.resourceList];
      // }
      // var item = tagId;
      const babyInfo = JSON.parse(localStorage.getItem("babyInfo"));
      this.pageWikipediaParams.loading = true;
      this.$http.get(
        "/expertPerspective/list",
        {
          isRecommend: item.id == 0, //是否最新推荐
          moduleType: item.moduleType, //模块id
          isCustomized: babyInfo && babyInfo.length ? true : false,
          typeId: item.id, //分类id
          ageId: this.periodid, //月龄id
          crmId: (this.userInfo && this.userInfo.crm_id) || 0,
          page: this.pageWikipediaParams.page,
          size: this.pageWikipediaParams.size,
        },
        (res) => {
          if (res.code == 200) {
            console.log(res);
            // 当前页视频数据
            if (this.loadParameter.moduleType == 0) {
              for (let i = 0; i < res.data.data.length; i++) {
                if (
                  res.data.data[i].moduleType == "2" ||
                  res.data.data[i].moduleType == "7"
                ) {
                  // console.log(res.data[i]);
                  this.videoData.push(res.data.data[i]);
                }
              }
            } else if (
              this.loadParameter.moduleType == 2 ||
              this.loadParameter.moduleType == 7
            ) {
              for (let i = 0; i < res.data.data.length; i++) {
                if (
                  res.data.data[i].hasOwnProperty("videoUrl") ||
                  res.data.data[i].hasOwnProperty("doctorName")
                ) {
                  console.log(res.data.data[i]);
                  this.videoData.push(res.data.data[i]);
                }
              }
            }
            console.log(this.videoData);
            this.isDisabled = false; //获取数据成功可以切换分类
            const { data, total, pageSize } = res.data;
            if (item.id != 0) {
              for (var i = 0; i < data.length; i++) {
                if (!data[i].contentUrl) {
                  data[i].moduleType = this.loadParameter.moduleType;
                }
              }
            }
            // this.dataList.push(...content)
            this.dataList = [...this.dataList, ...data];
            this.size += pageSize;
            if (this.size > this.pageWikipediaParams.size) {
              this.$refs.waterfall.initData("push", data);
            } else {
              this.$refs.waterfall.initData("init", this.dataList);
            }
            this.$nextTick(() => {
              if (this.size >= total) {
                this.pageWikipediaParams.finished = true;
              } else {
                this.pageWikipediaParams.page += 1;
                // this.pageWikipediaParams.loading = false;
              }
            });
            // 神策曝光埋点
            setTimeout(() => {
              xmhziyuanwei_data_expo.observe(
                "xmh5_ziyuanwei_view",
                ".water-burial-point",
                false
              );
              expertsView_content.observe(".info", false, {
                classification:
                  this.$refs.tabClassification.activeName || "最新推荐",
              });
            }, 300);
          } else {
            this.$toast("网络异常");
            this.pageWikipediaParams.loading = false;
            this.pageWikipediaParams.error = true;
            this.isDisabled = false;
          }
        },
        null,
        "lucky"
      );
    },

    // // 获取资源位接口  500状态
    // getResourceData() {
    //   // if(this.periodid != 0 && item.id == 0 ){
    //   API_.getResourceList(
    //       {
    //         label: this.periodid,
    //         crmId: this.userInfo && this.userInfo.crm_id,
    //       },
    //       (res) => {
    //         if (res.code === "200") {
    //           if (res.data.length > 0) {
    //             if (this.pageWikipediaParams.page === 1) {
    //               this.resourceList = res.data
    //               //  this.dataList.unshift(...res.data)
    //               //  this.$refs.waterfall.initData("init", this.dataList);
    //             }
    //             res.data.forEach((item, index) => {
    //               sensors.track("xmhh5_xzj_f5_view", {
    //                 xzj_f5_month: this.select,
    //                 xzj_f5_position: index + 1,
    //                 xzj_f5_title: item.name,
    //                 xzj_f5_type: this.getModuleType(item.moduleType)
    //               });
    //             })
    //           }
    //         }
    //         console.log(222222, this.dataList);
    //         this.getArticleList(this.tagList[0], 3333);  //获取列表数据

    //       }
    //   );
    //   // }
    // },

    getModuleType(item) {
      switch (item) {
        case "2":
          return "辅食";
        case "5":
          return "星妈课堂";
        case "7":
          return "京城名医";
        case "6":
          return "哈佛课堂";
      }
    },
    // 海报分享
    share: function (item) {
      if (
        this.getCookie("xmh_openid") == null ||
        this.getCookie("xmh_openid") == ""
      ) {
        location.href =
          "/xmh/v2/wechat/oauth2/authorize?url=" +
          encodeURIComponent(window.location.href);
      } else {
        // 2.营养厨房 5.星妈课堂 6.哈佛课堂 7.京城名医
        switch (this.loadParameter.moduleType || item.moduleType) {
          // 京城名医分享
          case "7": {
            if (this.isUserLogin()) {
              // this.$router.push({
              //   path: "/phoneLogin?redirect=" + window.location.href,
              // });
              globalGoLogin();
            } else {
              if (
                this.getCookie("xmh_openid") == null ||
                this.getCookie("xmh_openid") == ""
              ) {
                location.href =
                  "/xmh/v2/wechat/oauth2/authorize?url=" +
                  encodeURIComponent(window.location.href);
              } else {
                this.$http.get(
                  "/capital/share",
                  { id: item.moduleId || item.id },
                  (res) => {
                    if (res.code == 200) {
                      const params = {
                        type: "doctor",
                      };
                      res.data.title = item.name;
                      res.data.crmId = btoa(this.getUserInfo());
                      res.data.isExpertsView = 1;
                      this.drawPoster(params, res.data).then((res) => {
                        this.momPainting = res;
                        console.log(res);
                      });
                      $(".canvasposter").css("display", "block");
                    }
                  },
                  null,
                  "lucky"
                );
              }
            }

            break;
          }
          // 星妈课堂分享
          case "5": {
            this.$http.get(
              "/expertPerspective/shareCourse",
              { expertId: item.expertId },
              (res) => {
                if (res.code == 200) {
                  $(".canvasposter").css("display", "block");
                  const params = {
                    type: "pro",
                  };
                  res.data.startTime = item.startTime;
                  res.data.imgUrl = item.imgUrl;
                  res.data.title = item.name;
                  res.data.expert = {};
                  res.data.expert.realName = res.data.realName;
                  res.data.expert.hospital = res.data.hospital;
                  res.data.expert.position = res.data.position;
                  this.drawPoster(params, res.data).then((res) => {
                    this.momPainting = res;
                  });
                }
              }
            );

            break;
          }
          default: {
          }
        }
      }
    },
    // 星妈课堂预约
    signUp: function (item) {
      if (this.isUserLogin()) {
        // this.$router.push({
        //   path: "/phoneLogin?redirect=" + window.location.href,
        // });
        globalGoLogin();
      } else {
        var that = this;
        localStorage.setItem("courseSign", item.id || item.moduleId);
        this.wxJsSet.wxHandleBeforeFn(
          that,
          { type: "courseSign", number: 0 },
          that.signUpAjax(item)
        );
      }
    },
    signUpAjax: function (item) {
      console.log(item);
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      var openId = "";
      if (this.getCookie("xmh_openid") && this.getCookie("xmh_openid") != "")
        openId = this.getCookie("xmh_openid");
      this.$http.post(
        "/motherCourse/courseSignUp",
        {},
        {
          id: item.id || item.moduleId,
          crmId: this.userInfo.crm_id,
          mobile: this.userInfo.mobile,
          openId: openId,
          nickName: unescape(getCookie("xmh_nickname")),
        },
        (res) => {
          if (res.code === "200") {
            // $(".successToast").fadeIn(200);
            this.toastHtml = res.data;
            this.startTime = item.startTime;
            this.isShow = true;
            this.dataList.forEach((ite, ind) => {
              if (
                (item.id || item.moduleId) == (ite.id || ite.moduleId) &&
                item.name == ite.name
              ) {
                this.dataList[ind].signId = "1";
              }
            });
            console.log(this.dataList);
            localStorage.removeItem("courseSign");
          }
        },
        null,
        "lucky"
      );
    },
    // 点击月龄
    getDataByTag(name, id, flag) {
      this.sensorsFn("月龄切换");
      this.size = 0;
      this.tagList = [];
      this.dataList = [];
      this.pageWikipediaParams.page = 1;
      this.pageWikipediaParams.loading = false;
      this.pageWikipediaParams.finished = false;
      this.$refs.waterfall && this.$refs.waterfall.resetDefaultData();
      this.loadParameter.id = 0;
      this.loadParameter.moduleType = 0;
      this.select = name;
      this.periodid = id;
      this.$refs.tabClassification.activeFnTagId = -1;
      this.$refs.tabClassification.active = 0;
      this.getArticlClassify();
    },
    // 跳转详情
    clickHander(item, type, index) {
      sensors.track("xmhh5_xzj_f5_click", {
        xzj_f5_month: this.select,
        xzj_f5_position: index + 1,
        xzj_f5_title: item.name,
        xzj_f5_type: this.getModuleType(item.moduleType),
      });
      // 区分 资源位和普通流数据
      if (item.jumpType) {
        // alert(5234234234)
        sensors.track("xmh5_ziyuanwei_click", {
          ...this.resourceNiche(item),
          xmh5_ziyuanwei_position: index + 1,
        });
        advertisJump(item, this).then((res) => {
          if (res.jumpType === 5) {
            this.dataInfo = {
              ...res,
              contentUrl: res.jumpTargetUrl,
              contentPayUrl: res.jumpTargetUrl,
            };
            this.showVedio = true;
            this.isCommonPopup = true;
          }
        });
      } else {
        let module = "";
        if (this.loadParameter.moduleType > 0 && item.contentUrl === null) {
          module = String(this.loadParameter.moduleType);
        } else if (this.loadParameter.moduleType == 0 && !item.contentUrl) {
          // 2.营养厨房 5.星妈课堂 6.哈佛课堂 7.京城名医
          switch (item.moduleType) {
            case "2": {
              module = "2";
              break;
            }
            case "5": {
              module = "5";
              break;
            }
            case "6": {
              module = "6";
              break;
            }
            case "7": {
              module = "7";
              break;
            }
            default: {
            }
          }
        } else if (item.contentUrl) {
          location.href = item.contentUrl;
        }

        this.sensorsFn(
          "瀑布流内容",
          "",
          this.$refs.tabClassification.activeName || "最新推荐",
          item.name,
          !item.contentUrl ? "视频" : "其他"
        );
        // 2.营养厨房 5.星妈课堂 6.哈佛课堂 7.京城名医
        switch (module) {
          case "2":
            setTimeout(() => {
              this.$router.push(`/foodColumn/foodDetail/${item.id}`);
            }, 200);
            // this.getFoodDetail(item);
            break;
          case "5":
            this.$http.get(
              "/motherCourse/courseWatch",
              { id: item.id || item.moduleId },
              (res) => {
                console.log(res);
                if (res.code === 200) {
                  setTimeout(function () {
                    location.href = item.courseUrl;
                  }, 200);
                }
              },
              null,
              "lucky"
            );
            break;
          case "6":
            var pageSource = "class";
            if (this.$route.query.pageSource)
              pageSource = this.$route.query.pageSource;
            this.$router.push({
              path:
                "/harvard/" +
                (item.moduleId || item.id) +
                "?pageSource=" +
                pageSource +
                "&source=" +
                this.source,
            });
            break;
          case "7":
            sessionStorage.setItem("isDoctorDetail", "open"); //进入播放设置
            this.clearTime(); //停止全局定时器
            this.getDoctorDetail(item);
            break;
          default: {
          }
        }
      }
    },
    // 视频播放
    // 视频播放返回按钮
    hidevedioEvent() {
      sessionStorage.setItem("isDoctorDetail", "close"); //退出播放器设置退出状态
      this.interVal(); //打开全局注册计时器
      this.showVedio = false;
      // this.isCommonPopup = false;
      this.playStatus = false;
      var shareDataParams = {
        shareLink: location.origin + "/expertsView",
        shareDesc:
          "星妈会权威专家科普，哈佛专家、京城名医、营养名师，让你育儿不迷路~",
        shareTitle: "星专家",
        imgUrl: "https://image-mom.feihe.com/wxshare/zhuanjiashijiao.jpg", //必须是绝对路径
      };
      this.wxJsSet.wxShare("fx", shareDataParams, this);
    },
    // 获取京城名医视频详情
    getDoctorDetail(item) {
      console.log(item);
      let newItem = JSON.parse(JSON.stringify(item));
      var isPromotional; //是否是宣传视频
      const { code } = this.getmotherState();
      // 判断是宣传视频给个标识并且更换id
      if (newItem.id === "999") {
        newItem.id = this.promotionalId;
        isPromotional = true;
      }
      console.log(this.dataAll);
      API.catipalDcotorDetailNew(
        {},
        {
          id: newItem.moduleId || newItem.id,
          crmId: this.getUserInfo() || null,
          memberLevelCode: code || null,
        },
        (res) => {
          if (res.code === 200) {
            if (!res.data) {
              this.$toast("课程已下架");

              return false;
            }
            if (isPromotional) {
              res.data.isPromotional = true;
            }
            this.dataInfo = res.data;
            commonOperationEvent({
              itemId: newItem.moduleId || newItem.id,
              crmId: until.getUserInfo(),
              type: 0,
              columnIds: ["5"],
              actionType: 4,
              contentType: 3,
            });

            this.showVedio = true;
            this.isCommonPopup = false;
          }
        }
      );
    },
    // 获取营养厨房视频详情
    getFoodDetail(item) {
      console.log(item);
      // 获取详情
      API_.getFoodDetai(
        {
          id: item.id || item.moduleId,
          crmId: this.getUserInfo() || "",
        },
        (res) => {
          if (res.code === "200") {
            this.dataInfo = Object.assign({ isFood: 1 }, res.data);
            console.log(this.dataInfo);
            this.showVedio = true;
            this.isCommonPopup = false;
          }
        }
      );
    },
    // 切换下一个音频
    switchoverVideoNext(id) {
      let index = this.videoData.findIndex((item) => {
        return (item.moduleId || item.id) == id;
      });
      console.log(index, this.videoData.length - 1);
      if (index >= this.videoData.length - 1) {
        //到底了
      } else {
        console.log(this.videoData[index + 1], this.loadParameter);
        if (
          this.videoData[index + 1].moduleType == 2 ||
          this.loadParameter.moduleType == 2
        ) {
          this.getFoodDetail(this.videoData[index + 1]);
        } else {
          this.getDoctorDetail(this.videoData[index + 1]);
        }
        // this.getDoctorDetail(this.videoData[index + 1]);
        // this.dataInfo = this.dataAll[index + 1];
      }
    },
    posterSaveStart: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    posterSaveEnd: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    // 星妈课堂疫情海报保存
    success(src) {
      this.src = src;
    },
    fail(err) {
      console.log("fail", err);
    },
    // 瀑布流样式完毕
    styleEnd() {
      this.pageWikipediaParams.loading = false;
    },
    // 返回
    backHander() {
      if (this.$route.query.from == "home") {
        this.$router.go(-1);
      } else {
        location.href = "/home";
      }
      // location.href = "/home";
    },
    // 海报关闭
    close(e) {
      if (e == "bjdoctor") {
        $(".bjdoctor-canvasposter").css("display", "none");
      } else {
        $(".mom-canvasposter").css("display", "none");
      }
    },
    // 十秒未登陆
    userLogin() {
      if (this.isUserLogin()) {
        this.$refs.childVideo.Player.pause();
        this.checkLogin = true;
      }
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
      this.$refs.childVideo.isLogin();
      this.loginRegistSensors("确定");
    },
    // 取消
    cancleWay() {
      this.$refs.childVideo.Player.pause();
      this.$refs.childVideo.Player.currentTime = 9;
      this.checkLogin = false;
      this.loginRegistSensors("取消");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "京城名医",
      });
    },
    // 二维码分享活动扫码量增加
    addQrcodeNum() {
      let queryInfo = this.$route.query;
      // 判断是否是分享二维码进来的
      if (queryInfo.id && queryInfo.crmId && queryInfo.title) {
        this.active = 0;
        this.select = "全部";
        this.$http.post(
          "/starMom/getUser",
          {},
          { crmId: atob(queryInfo.crmId) },
          (res) => {
            if (res.code === "200") {
              // open_id是否存在
              let isCancel = res.data.memberChannel.some((item, index) => {
                return item.account_type === "open_id";
              });
              // 判断二维码分享者是否处于注销状态 isCancel为true并且mobile存在 未注销状态
              if (isCancel && res.data.mobile && res.data.mobile.length > 0) {
                // 分享二维码进入请求
                const { id: capitalId, crmId } = this.$route.query;
                API.addQrcode({}, { capitalId, crmId: atob(crmId) }, (res) => {
                  if (res.code == "200") {
                    sensors.track("Code_scanning_times", {
                      content_title: queryInfo.title,
                    });
                  }
                });
              }
            }
          }
        );
      }
    },
    returnDate: function (date) {
      date = new Date(Date.parse(date.replace(/-/g, "/")));
      var month = new Date(date).getMonth() + 1;
      var day = new Date(date).getDate();
      var weekday = new Array(7);
      weekday[0] = "星期日";
      weekday[1] = "星期一";
      weekday[2] = "星期二";
      weekday[3] = "星期三";
      weekday[4] = "星期四";
      weekday[5] = "星期五";
      weekday[6] = "星期六";
      var week = weekday[new Date(date).getDay()];
      var hours = new Date(date).getHours();
      if (hours < 10) hours = "0" + hours;
      var minute = new Date(date).getMinutes();
      if (minute < 10) minute = "0" + minute;
      console.log(month + "月" + day + "日 " + hours + ":" + minute);
      return month + "月" + day + "日 " + hours + ":" + minute;
    },
    // 搜索框点击
    inputFocusHander() {
      this.sensorsFn("搜索");
      sessionStorage.setItem("searchVal", "expertsView");
      setTimeout(() => {
        this.$router.push({
          path: "/search",
          query: {
            searchIndex: "home",
          },
        });
      });
    },
    // 埋点
    sensorsFn(type, name1 = "", name2 = "", name3 = "", name4 = "") {
      sensors.track("xingmahui_zhuanjiashijiao_click", {
        zhuanjiashijiao_module: type,
        zhuanjiashijiao_tuijianlanmu: name1,
        zhuanjiashijiao_class: name2,
        content_title: name3,
        content_type: name4,
      });
    },
    // 播放埋点
    playerBuriedpoint({ num, total, percent, id }) {
      console.log(this.dataInfo);
      this.playIndex++;
      console.log(this.videoData, id);
      let index = this.videoData.findIndex((item) => {
        return item.id === id;
      });
      if (this.playIndex == 1) {
        sensors.track("Audio_and_video_playback", {
          content_id: this.dataInfo.id,
          content_title: this.dataInfo.name || this.dataInfo.recipeName,
          length_of_time: total,
          position: index,
          content_topic: "宣传片",
          Membership_level: this.getmotherState().name,
          video_duration: num,
          is_finished: percent >= 0.8 ? true : false,
          Content_column: this.dataInfo.isFood ? "营养厨房" : "京城名医",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./less/list.less";
</style>
